import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4f5e0a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pointsMall" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_4 = { class: "paging" }

import { ref, computed, onMounted } from "vue";
import store from "@/store";
import { getMallList } from "@/api/pointsMall";
import { queryServiceLists } from "@/api/userCenter";
import cards from "./cards.vue";
import howToGetScore from "./howToGetScore.vue";
import { change } from "dom7";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const isMobile = computed(() => store.state.isMobile);
const scoreBalance = computed(() => store.state.userInfo.scoreBalance);
const pages: { pageIndex: number; pageSize: number; total: number } = {
  pageIndex: 1,
  pageSize: 20,
  total: 0,
};

onMounted(() => {
  getScoreData(pages);
});
// 获取商品列表
const scoreList = ref({});
const getScoreData = (data: { pageIndex: number; pageSize: number }) => {
  getMallList({
    pageIndex: pages.pageIndex,
    pageSize: pages.pageSize,
  }).then((res: any) => {
    if (res.code == 0) {
      scoreList.value = res.data.records;
      pages.total = res.data.total;
      store.dispatch("getUserInfo");
    }
  });
};

const changeHowToGetScoreState = () => {
  if (!isMobile.value) {
    store.commit("howToGetScoreState", true);
  } else {
    router.push({
      path: "/rewards/article",
    });
  }
};

const handlerPage = () => {
  getScoreData(pages);
};

return (_ctx: any,_cache: any) => {
  const _component_SecondPageHeader = _resolveComponent("SecondPageHeader")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_component_SecondPageHeader, {
          key: 0,
          class: "headerTitle",
          title: _ctx.$t('pointsMall.titleName'),
          toPath: "userCenter/personal"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_unref(isMobile) ? 'scoreBoxM' : 'scoreBoxPc')
    }, [
      (!_unref(isMobile))
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t("pointsMall.titleName")) + " ", 1),
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_unref(scoreBalance)) + " " + _toDisplayString(_ctx.$t("pointsMall.score")) + " ", 1),
        _createElementVNode("i", { onClick: changeHowToGetScoreState })
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mallBox", _unref(isMobile) ? '' : 'mallBoxPc'])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scoreList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["comCards", _unref(isMobile) ? 'cardMobile' : 'cardPc']),
          key: index
        }, [
          _createVNode(cards, {
            cardData: item,
            onGetScoreData: _cache[0] || (_cache[0] = ($event: any) => (getScoreData(pages)))
          }, null, 8, ["cardData"])
        ], 2))
      }), 128))
    ], 2),
    _createVNode(howToGetScore),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        class: "pagination",
        background: "",
        layout: "prev, pager, next",
        onSizeChange: handlerPage,
        onCurrentChange: handlerPage,
        "current-page": pages.pageIndex,
        "onUpdate:current-page": _cache[1] || (_cache[1] = ($event: any) => ((pages.pageIndex) = $event)),
        "hide-on-single-page": "",
        "page-size": pages.pageSize,
        "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((pages.pageSize) = $event)),
        total: pages.total
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ]))
}
}

})